/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：328
 */

"use strict"

export { r as a }
export { o as b }
export { CoCoAPP as c }
var r = "喜欢我的作品吗？点个赞再走！"
var o = "作者很懒，没有留下任何操作说明！"
var /* [auto-meaningful-name] */CoCoAPP = "我用CoCo编辑器做了个很棒的APP，快来看看吧！"
export default r
